export const teamMembers = [
  {
    name: 'Akinyinka Akintunde',
    role: 'Business Development Manager',
    imageSrc: 'team/akinyinka-akintunde.jpg',
    team: 'Business Development',
  },
  {
    name: 'Farhat Kunmi-Olayiwola',
    role: 'Corporate Strategist',
    imageSrc: 'team/farhat-kunmi.jpg',
    team: 'Business Development',
  },
  {
    name: 'Iruansi Itoandon',
    role: 'Commercial Manager',
    imageSrc: 'team/iranusi-itoandon.jpg',
    team: 'Commercial',
  },
  {
    name: 'Khadijah Shogbuyi',
    role: 'Business Development Analyst',
    imageSrc: 'team/khadijah-shogbuyi.jpg',
    team: 'Business Development',
  },
  {
    name: 'Nancy Ochonwe',
    role: 'Trading Manager',
    imageSrc: 'team/nancy-ochone.jpg',
    team: 'Business Assurance',
  },
  {
    name: 'Sam Ukoh',
    role: 'Commercial Officer',
    imageSrc: 'team/sam-ukoh.jpg',
    team: 'Commercial',
  },
  {
    name: 'Maryam Brimmo',
    role: 'MIS Administrator',
    imageSrc: 'team/maryam-brimmo.jpg',
    team: 'Business Development',
  },
  {
    name: 'Yusuf Galtima',
    role: 'Clearing & Settlement Analyst',
    imageSrc: 'team/yusif-galtima.jpg',
    team: 'Business Assurance',
  },
  {
    name: 'Kingsley John',
    role: ' Administrative Assistant',
    imageSrc: 'team/kingsley-john.jpg',
    team: 'Commercial',
  },
  {
    name: 'Obianuju Okafor',
    role: 'Brand & Communications Lead',
    imageSrc: 'team/obianuju-okafor.jpg',
    team: 'Business Development',
  },
  {
    name: 'Joseph Oguntunde',
    role: ' Sales Operations Manager',
    imageSrc: 'team/joseph-oguntunde.jpg',
    team: 'Commercial',
  },
  {
    name: 'Isioma Oride',
    role: 'Internal Control & Compliance Manager',
    imageSrc: 'team/isioma-oride.jpeg',
    team: 'Business Assurance',
  },
  {
    name: 'Umar Aliyu',
    role: 'Treasury & Settlement Analyst',
    imageSrc: 'team/umar-aliyu.jpg',
    team: 'Business Assurance',
  },
  {
    name: 'Maryam Yusuf',
    role: 'Software Developer',
    imageSrc: 'team/maryam-yusuf.jpg',
    team: 'Business Development',
  },
  {
    name: 'Ikechukwu Agwu',
    role: 'UI/UX Front Developer',
    imageSrc: 'team/ikechukwu-agwu.jpg',
    team: 'Business Development',
  },
  {
    name: 'Nonye Ikenye',
    role: 'Corporate Communications Intern',
    imageSrc: 'team/nonye-ikenye.jpg',
    team: 'Business Development',
  },
  {
    name: 'Adanna Atuonwu',
    role: 'Corporate Communications Analyst',
    imageSrc: 'team/adanna-atuonwu.jpg',
    team: 'Business Development',
  },
  {
    name: 'Tony Nwamarah',
    role: 'Brand & Communications Executive',
    imageSrc: 'team/tony-nwamarah.jpg',
    team: 'Business Development',
  },
  {
    name: 'Abdulkadir Ajia',
    role: 'Clearing & Settlement Analyst',
    imageSrc: 'team/abdulkadir-ajia.jpg',
    team: 'Business Assurance',
  },
  {
    name: 'Isaiah Morakinya',
    role: 'Warehouse Manager Kachai Kaduna',
    imageSrc: 'team/isaiah-morakinya.jpg',
    team: 'Commercial',
  },
  {
    name: 'Tobi Badmus',
    role: 'Sales Operations Analyst',
    imageSrc: 'team/tobi-badmus.jpg',
    team: 'Commercial',
  },
  {
    name: 'Zarah Kaigama',
    role: 'Finance Intern',
    imageSrc: 'team/zarah-kaigama.jpg',
    team: 'Business Assurance',
  },
  {
    name: 'Kunle Ajani',
    role: 'Warehouse Manager, Gboko Benue',
    imageSrc: 'team/kunle-ajani.jpeg',
    team: 'Commercial',
  },
  {
    name: 'Kindness Ezenma',
    role: 'Trade Execution Intern',
    imageSrc: 'team/kindness-ezenma.jpg',
    team: 'Business Assurance',
  },
  {
    name: 'Soji Omotoye',
    role: 'Warehouse Manager Soba Kaduna',
    imageSrc: 'team/soji-omotoye.jpg',
    team: 'Commercial',
  },
  {
    name: 'Salau Abdulateef',
    role: 'Warehouse Manager Jengre Plateau',
    imageSrc: 'team/salau-abdulateef.jpg',
    team: 'Commercial',
  },
  {
    name: 'Alphonsus Osaba',
    role: 'Warehouse Manager Buruku Benue',
    imageSrc: 'team/alphonsus-osaba.jpg',
    team: 'Commercial',
  },
  {
    name: 'Adam Mohammed',
    role: 'Internal Control & Compliance Officer',
    imageSrc: 'team/adam-mohammed.jpg',
    team: 'Business Assurance',
  },
  {
    name: 'Ibrahim Ishaku',
    role: 'Warehouse Manager Makarfi Kaduna',
    imageSrc: 'team/ibrahim-ishaku.jpg',
    team: 'Commercial',
  },
  {
    name: 'Michael Popoola',
    role: 'Warehouse Manager Pampegua Kaduna',
    imageSrc: 'team/michael-popoola.jpg',
    team: 'Commercial',
  },
  {
    name: 'Joy Felix',
    role: 'Commercial Officer, Kaduna III',
    imageSrc: 'team/joy-felix.jpg',
    team: 'Commercial',
  },
  {
    name: 'David Adeniyi',
    role: 'Warehouse Manager, Edo Warehouse',
    imageSrc: 'team/david-adeniyi.jpg',
    team: 'Commercial',
  },
  {
    name: 'Ibrahim Saidu',
    role: 'Commercial Officer, Kaduna II',
    imageSrc: 'team/ibrahim-saidu.jpg',
    team: 'Commercial',
  },
  {
    name: 'Zaki Isuwa',
    role: 'Warehouse Manager, Bakori Warehouse',
    imageSrc: 'team/zaki-isuwa.jpg',
    team: 'Commercial',
  },
  {
    name: 'Dzahemen Iliambee',
    role: 'Commercial Officer Jigawa',
    imageSrc: 'team/dzahemen-iliambee.jpg',
    team: 'Commercial',
  },
  {
    name: 'Abdulkarim Abdullahi',
    role: 'Commercial Officer Katsina',
    imageSrc: 'team/abdulkarim-abdullahi.jpg',
    team: 'Commercial',
  },
  {
    name: 'Emmanuel Achi',
    role: 'Warehouse Manager Anchau',
    imageSrc: 'team/emmanuel-achi.jpg',
    team: 'Commercial',
  },

  {
    name: 'Queen Momoh',
    role: 'Office Assistant',
    imageSrc: 'team/queen-momoh.jpg',
    team: 'Business Development',
  },
  {
    name: 'Kamaldeen Raji',
    role: 'Key Supply Chain Manager',
    imageSrc: 'team/kamaldeen-raji.jpg',
    team: 'Commercial',
  },
  {
    name: 'Jabir Musa',
    role: 'MIS Software Developer Intern',
    imageSrc: 'team/jabir-musa.jpg',
    team: 'Business Development',
  },
  {
    name: 'Bolaji Hassan',
    role: 'Warehouse Manager Pampaida',
    imageSrc: 'team/bolaji-hassan.jpg',
    team: 'Commercial',
  },
];

export const ALL_TRYBES_MEN = 'all';
